var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReadMore = function SvgReadMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 15,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#888D96"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 7.5,
    r: 1.5,
    fill: "#888D96"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 13.5,
    r: 1.5,
    fill: "#888D96"
  })));
};
export default SvgReadMore;